export default __webpack_public_path__ + "images/e1796be7c1497a3470ac9de5c150c69c-smart-deal-graph.svg";